export default "__VITE_ASSET__D7qcS2g1__"